export const SET_CHANGE_ACCOUNT_LOADED = "SET_CHANGE_ACCOUNT_LOADED";
